// extracted by mini-css-extract-plugin
export var gif = "_ld-0";